import React, { RefObject } from 'react';
import { Grid, Header, Icon, Menu, Sticky, Visibility } from "semantic-ui-react";
import { strings } from '../..';
import { DestinatarioMatricola, DestinatarioMatricole, FiltroMatricole, Matricola } from '../../core-assistenza';

type SelezionaMatricolaComputerProps = {
    destinatariMatricole: ReadonlyArray<DestinatarioMatricola>,
    onSelectMatricola: (matricola: Matricola) => void,
    loadMatricole: (search?: string) => void
}

type SelezionaMatricolaComputerState = {
    active: string,
    selezionato: string
}

export default class SelezionaMatricolaComputer extends React.Component<SelezionaMatricolaComputerProps, SelezionaMatricolaComputerState> {
    constructor(props: SelezionaMatricolaComputerProps) {
        super(props);

        this.state = { active: '', selezionato: '' };
    }

    componentDidUpdate() {
        if (this.state.active === '' && this.props.destinatariMatricole !== []) {
            if (this.props.destinatariMatricole[0]) {
                this.setState({ active: this.props.destinatariMatricole[0].idDestinatario });
            }
        }
    }

    render() {
        const { onSelectMatricola } = this.props;
        const destinatariMatricole = this.props.destinatariMatricole || [];

        const destinatariComponents: Array<JSX.Element> = [];
        const matricoleComponents: Array<JSX.Element> = [];
        const refs = destinatariMatricole.reduce((acc: Map<string, RefObject<HTMLDivElement>>, value: DestinatarioMatricola) => {
            acc.set(value.idDestinatario, React.createRef<HTMLDivElement>());
            return acc;
        }, new Map<string, RefObject<HTMLDivElement>>());
        const handleClick = (id: string) => {
            refs.get(id)!.current!.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });

            this.setState({ selezionato: id });
        };

        destinatariMatricole.forEach(destinatario => {
            matricoleComponents.push(
                <div key={destinatario.idDestinatario} ref={refs.get(destinatario.idDestinatario)}>
                    <Visibility once={false}
                        onBottomPassedReverse={() => this.setState({ active: destinatario.idDestinatario })}
                        onTopPassed={() => this.setState({ active: destinatario.idDestinatario })}>
                        <DestinatarioMatricole
                            key={destinatario.idDestinatario}
                            elemento={destinatario}
                            onSelectMatricola={onSelectMatricola}
                            active={this.state.selezionato}
                        />
                    </Visibility>
                </div>
            );
            destinatariComponents.push(
                <Menu.Item
                    key={destinatario.idDestinatario}
                    onClick={() => handleClick(destinatario.idDestinatario)}
                    active={this.state.active === destinatario.idDestinatario}>
                    {destinatario.destinatario}
                </Menu.Item>
            );
        });

        const gridRef = React.createRef<HTMLDivElement>();

        return (
            <Grid centered>
                <Grid.Row>
                    <Grid.Column tablet='15' computer='6'>
                        <FiltroMatricole onSearch={(search: string) => this.props.loadMatricole(search)} />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width='4' textAlign='left'>
                        <Sticky context={gridRef} offset={100}>
                            <Menu vertical fluid>
                                <Menu.Item header>
                                    <Header as='h3'>
                                        <Icon name='home' />
                                        {strings.chiamate.selezionaMatricola.selezionaSede}
                                    </Header>
                                </Menu.Item>
                                {destinatariComponents}
                            </Menu>
                        </Sticky>
                    </Grid.Column>
                    <Grid.Column width='11'>
                        <div ref={gridRef}>
                            <Header as='h3' attached='top'>
                                <Icon name='print' />
                                {strings.chiamate.selezionaMatricola.selezionaMatricola}
                            </Header>
                            {matricoleComponents}
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}